import ChatInput from 'components/chat-input'
import ShareModal from './share-modal.vue'

export default {
  __name: 'share-chat',
  setup(__props, { expose: __expose }) {
  __expose();


const __returned__ = { get ChatInput() { return ChatInput }, ShareModal }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

}